/**
 * Custom select dropdown. Works with gravity forms select inputs
 * @link https://www.w3schools.com/howto/howto_custom_select.asp
 */
jQuery( document ).ready(function() {

  // function closeAllSelect(elmnt) {
  //   /*a function that will close all select boxes in the document,
  //   except the current select box:*/
  //   var x, y, i, arrNo = [];
  //   x = document.getElementsByClassName("select-items");
  //   y = document.getElementsByClassName("select-selected");
  //   for (i = 0; i < y.length; i++) {
  //     if (elmnt === y[i]) {
  //       arrNo.push(i);
  //     } else {
  //       y[i].classList.remove("select-arrow-active");
  //     }
  //   }
  //   for (i = 0; i < x.length; i++) {
  //     if (arrNo.indexOf(i)) {
  //       x[i].classList.add("select-hide");
  //     }
  //   }
  // }

  // function handleClick(a) {
  //   a.addEventListener("click", function(e) {
  //       /*when the select box is clicked, close any other select boxes,
  //       and open/close the current select box:*/
  //       e.stopPropagation();
  //       closeAllSelect(this);
  //       this.nextSibling.classList.toggle("select-hide");
  //       this.classList.toggle("select-arrow-active");
  //   });
  // }

  // var x, i, j, selElmnt, a, b, c;
  // /*look for any elements with the class "custom-select":*/
  // x = document.getElementsByClassName("ginput_container_select");

  // for (i = 0; i < x.length; i++) {
  //   selElmnt = x[i].getElementsByTagName("select")[0];
  //   /*for each element, create a new DIV that will act as the selected item:*/
  //   a = document.createElement("DIV");
  //   a.setAttribute("class", "select-selected");
  //   a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
  //   x[i].appendChild(a);
  //   /*for each element, create a new DIV that will contain the option list:*/
  //   b = document.createElement("DIV");
  //   b.setAttribute("class", "select-items select-hide");
  //   for (j = 0; j < selElmnt.length; j++) {
  //     /*for each option in the original select element,
  //     create a new DIV that will act as an option item:*/
  //     c = document.createElement("DIV");
  //     c.innerHTML = selElmnt.options[j].innerHTML;
  //     c.addEventListener("click", function(e) {
  //         /*when an item is clicked, update the original select box,
  //         and the selected item:*/
  //         var y, i, k, s, h;
  //         s = this.parentNode.parentNode.getElementsByTagName("select")[0];
  //         h = this.parentNode.previousSibling;
  //         for (i = 0; i < s.length; i++) {
  //           if (s.options[i].innerHTML === this.innerHTML) {
  //             s.selectedIndex = i;
  //             h.innerHTML = this.innerHTML;
  //             y = this.parentNode.getElementsByClassName("same-as-selected");
  //             for (k = 0; k < y.length; k++) {
  //               y[k].removeAttribute("class");
  //             }
  //             this.setAttribute("class", "same-as-selected");
  //             break;
  //           }
  //         }
  //         h.click();
  //     });
  //     b.appendChild(c);
  //   }
  //   x[i].appendChild(b);
  //   handleClick(a);
  // }

  // /*if the user clicks anywhere outside the select box,
  // then close all select boxes:*/
  // document.addEventListener("click", closeAllSelect);

  /*
  * List item accordion
  */
  var sb_accordion = function() {
    var toggle_btns = document.querySelectorAll('.toggle-accordion');

    var sb_accordion_toggle = function(){
      this.classList.toggle('active');
    };

    for (var i = 0; i < toggle_btns.length; i++) {
      toggle_btns[i].addEventListener('click', sb_accordion_toggle, false);
    }
  };

  sb_accordion();

});

/**
 * Focus on next element
 */
jQuery(document).on('gform_post_render', function(event, form_id, current_page){
  var focusOnNextFields = document.querySelectorAll('.js-scroll-to-next-on-change');
  if (focusOnNextFields.length) {
    for (var i = focusOnNextFields.length - 1; i >= 0; i--) {
      var inputs = focusOnNextFields[i].querySelectorAll('input');
      if (inputs.length) {
        for (var j = 0; j < inputs.length; j++) {
          inputs[j].addEventListener('change', function(e) {
            var parent = e.currentTarget;
            while (parent && (parent = parent.parentElement) && parent.classList && !parent.classList.contains('gfield'));
            if (parent && parent.classList.contains('gfield')) {
              var parentSibling = parent.nextElementSibling;
              if (parentSibling) {
                // if there's conditional logic, the element might not be available instantly
                setTimeout(function(el) {
                  parentSibling.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
                }, 200, parentSibling);
              }
            }
          });
        }
      }
    }
  }
});
